import React, { useState } from 'react';

const style = {
  color: '#fff',
  boxShadow: 'none',
  background: 'rgba(0, 167, 225, 0.1)',
};

type CartProductQuantityInputProps = {
  id: number;
  quantity: number;
  onChange: (quantity: number) => void;
};

function CartProductQuantityInput({ id, quantity, onChange }: CartProductQuantityInputProps) {
  const [qty, setQty] = useState<string>(quantity.toString());
  const handleFocus = (event: React.FocusEvent) => {
    const target = event.target as HTMLInputElement;
    target.select();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQty(event.target.value);

    if (event.target.value !== '') {
      onChange(parseInt(event.target.value));
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === 13) event.preventDefault();
    return false;
  };

  return (
    <React.Fragment>
      <input
        style={style}
        className="quantity_select_input tar"
        id={`quantity_select_${id}`}
        data-id={id}
        type="number"
        min="1"
        value={qty}
        required
        onFocus={handleFocus}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      <label htmlFor={`quantity_select_${id}`} className="screen-reader-text">
        Change quantity
      </label>
    </React.Fragment>
  );
}

export default CartProductQuantityInput;
